// extracted by mini-css-extract-plugin
module.exports = {"btn-submit":"formRequestPassword_btn-submit__1C6xr","form":"formRequestPassword_form__1HfjJ","field-group":"formRequestPassword_field-group__3s5PK"};